//Implement modal dialog window

import {FadeAnimation} from './animations/FadeAnimation';

declare var callback:any;

export class Modal {

    public static open(el:string|JQuery<HTMLElement>,post:any=undefined) {
        var modal_id=(typeof el!='string')?el.attr("data-modal"):el;
        callback({
            element: (typeof el!='string')?el:undefined,
            post: post,
            name: 'modal',
            arguments: modal_id,
            protector: (e:JQuery<HTMLElement>)=>{
                let target = parseFloat($(e).css('opacity'))??1;
                new FadeAnimation($(e)).to(target).play();
            },
            success: async function () {
                var mdl=this[0];
                $("html").addClass("modal-open");
                $(".modal-"+modal_id).not(mdl).remove();
                $(mdl).on("close",()=>{Modal.close($(mdl))});
                await new FadeAnimation($(mdl)).to(1).play();
            }
        });
    }

    public static async close(mdl:JQuery<HTMLElement>) {
        if (!mdl.length) return;
        await Promise.all([
            new FadeAnimation($(mdl)).to(0).play(),
            new FadeAnimation('.protector').to(0).play()
        ]);
        mdl.remove();
        $('.protector').remove();
        $("html").removeClass("modal-open");
    }

}

export {};